import React from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import withMixpanel, { GROUP_DELETED } from 'utils/mixpanel'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as groupModule from 'modules/group'

const styles = theme => ({
  root: {
    width: 424,
    textAlign: 'center',
  },
  description: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px`,
  },
  actions: {
    maxWidth: 360,
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

class DeleteGroupConfirm extends React.Component {
  onCancelClick = () => {
    this.props.handleClose()
  };

  onConfirmClick = () => {
    const {
      data, actions, track, organisation, handleClose
    } = this.props

    actions.deleteGroup(organisation, data, () => {
      track(GROUP_DELETED)
    })
    handleClose()
  };

  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        <Typography variant="h1">Delete group</Typography>
        <div className={classes.description}>
          <Typography>Are you sure you want to delete this group?</Typography>
          <Typography>
            All traps with in this group will become unassigned.
          </Typography>
        </div>
        <div className={classes.actions}>
          <SubmitButton
            size="medium"
            color="primary"
            variant="secondary"
            onClick={this.onCancelClick}>
            Cancel
          </SubmitButton>
          <SubmitButton
            size="medium"
            color="primary"
            variant="primary"
            onClick={this.onConfirmClick}>
            Confirm
          </SubmitButton>
        </div>
      </div>
    )
  }
}

DeleteGroupConfirm.propTypes = {
  track: PropTypes.func,
  data: PropTypes.object,
  classes: PropTypes.object,
  actions: PropTypes.object,
  handleClose: PropTypes.func,
  organisation: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    organisation: idx(state, _ => _.organisation.selected) || {},
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, groupModule)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMixpanel(withStyles(styles)(DeleteGroupConfirm)))



// WEBPACK FOOTER //
// ./src/components/molecules/DeleteGroupConfirm.js